import { render, staticRenderFns } from "./comboProduct.vue?vue&type=template&id=2f64c49c&scoped=true"
import script from "./comboProduct.vue?vue&type=script&lang=js"
export * from "./comboProduct.vue?vue&type=script&lang=js"
import style0 from "./comboProduct.vue?vue&type=style&index=0&id=2f64c49c&prod&lang=scss"
import style1 from "./comboProduct.vue?vue&type=style&index=1&id=2f64c49c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f64c49c",
  null
  
)

export default component.exports